export default __webpack_public_path__ + "static/media/pause.d589351f.svg";